<template>
  <div class="notification-page">
    <div class="page-header">
      <h1>通知中心</h1>
      <p>管理系统通知和消息</p>
    </div>

    <!-- 通知统计 -->
    <div class="notification-stats">
      <div class="stat-card">
        <div class="stat-icon common">
          <el-icon><ChatDotRound /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ commonCount }}</div>
          <div class="stat-label">普通消息</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon system">
          <el-icon><Setting /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ total }}</div>
          <div class="stat-label">全部通知数</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon weight">
          <el-icon><Scale /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ weightCount }}</div>
          <div class="stat-label">体重提醒</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon schedule">
          <el-icon><Calendar /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ scheduleCount }}</div>
          <div class="stat-label">排班提醒</div>
        </div>
      </div>
    </div>

    <!-- 操作栏 -->
    <div class="action-bar">
      <div class="filter-section">
        <el-select v-model="typeFilter" placeholder="通知类型" clearable style="width: 150px" @change="fetchNotifications">
          <el-option label="全部类型" value="" />
          <el-option label="普通消息" value="0" />
          <el-option label="排班提醒" value="1" />
          <el-option label="透析调研" value="2" />
          <el-option label="称完体重提示" value="3" />
          <el-option label="下次称体重提示" value="4" />
          <el-option label="系统通知" value="5" />
        </el-select>
        
        <!-- <el-select v-model="statusFilter" placeholder="阅读状态" clearable style="width: 150px" @change="fetchNotifications">
          <el-option label="全部状态" value="" />
          <el-option label="未读" value="unread" />
          <el-option label="已读" value="read" />
        </el-select> -->
        
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 300px"
          @change="fetchNotifications"
        />
      </div>
      
      <div class="action-buttons">
        <!-- <el-button @click="markAllRead">
          <el-icon><Check /></el-icon>
          全部已读
        </el-button>
        <el-button @click="clearAll">
          <el-icon><Delete /></el-icon>
          清空通知
        </el-button> -->
        <el-button type="primary" @click="sendNotification">
          <el-icon><Plus /></el-icon>
          发送通知
        </el-button>
      </div>
    </div>

    <!-- 通知列表 -->
    <div class="notification-list">
      <div class="list-header">
        <h3>通知列表</h3>
        <el-button type="text" @click="fetchNotifications">刷新</el-button>
      </div>
      
      <div class="notification-items" v-loading="loading">
        <div 
          v-for="notification in notifications" 
          :key="notification.id"
          class="notification-item"
          :class="{ unread: !notification.isRead, important: notification.priority === 'high' }"
          @click="toggleRead(notification)"
        >
          <div class="notification-icon">
            <el-icon v-if="notification.type === '0'"><ChatDotRound /></el-icon>
            <el-icon v-else-if="notification.type === '1'"><Calendar /></el-icon>
            <el-icon v-else-if="notification.type === '2'"><Document /></el-icon>
            <el-icon v-else-if="notification.type === '3'"><Scale /></el-icon>
            <el-icon v-else-if="notification.type === '4'"><Bell /></el-icon>
            <el-icon v-else><Bell /></el-icon>
          </div>
          
          <div class="notification-content">
            <div class="notification-header">
              <div class="notification-title">
                {{ notification.title  }}
                <el-tag 
                  v-if="notification.priority === 'high'" 
                  type="danger" 
                  size="small"
                  style="margin-left: 8px"
                >
                  重要
                </el-tag>
              </div>
              <div class="notification-time">{{  ' (' + (notification.createTime) + ')   '+ formatTime(notification.createTime) }}</div>
            </div>
            
            <div class="notification-message">{{ notification.message }}</div>
            
            <div class="notification-footer">
              <span class="notification-type">{{ getTypeLabel(notification.type) }}</span>
              <div class="notification-actions">
                <el-button 
                  type="text" 
                  size="small" 
                  @click.stop="viewDetail(notification)"
                >
                  查看详情
                </el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click.stop="deleteNotification(notification)"
                  style="color: #f56c6c;"
                  disabled
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
          
          <div class="notification-status">
            <div v-if="!notification.isRead" class="unread-dot"></div>
          </div>
        </div>
        
        <!-- 空状态 -->
        <div v-if="!loading && notifications.length === 0" class="empty-state">
          <el-empty description="暂无通知" />
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 发送通知对话框 -->
    <el-dialog
      v-model="notificationDialogVisible"
      title="发送通知"
      width="600px"
    >
      <el-form :model="notificationForm" label-width="100px">
        <el-form-item label="通知类型">
          <el-select v-model="notificationForm.type" placeholder="选择通知类型" disabled="true">
            <el-option label="一般消息" value="0" />
            <el-option label="排班提醒" value="1" />
            <el-option label="透析调研" value="2" />
            <el-option label="称完体重" value="3" />
            <el-option label="下次称体重提示" value="4" />
            <el-option label="系统通知" value="5" />
          </el-select>
        </el-form-item>
        
        <!-- <el-form-item label="优先级">
          <el-radio-group v-model="notificationForm.priority">
            <el-radio label="low">普通</el-radio>
            <el-radio label="medium">中等</el-radio>
            <el-radio label="high">重要</el-radio>
          </el-radio-group>
        </el-form-item> -->
        
        <el-form-item label="标题">
          <el-input v-model="notificationForm.title" placeholder="请输入通知标题"/>
        </el-form-item>
        
        <el-form-item label="内容">
          <el-input
            v-model="notificationForm.message"
            type="textarea"
            :rows="4"
            placeholder="请输入通知内容"
          />
        </el-form-item>
        
        <el-form-item label="发送时间">
          <el-date-picker
            v-model="notificationForm.sendTime"
            type="datetime"
            placeholder="选择发送时间（留空为立即发送）"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="notificationDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="sendNotificationSubmit" :loading="sending">发送</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="通知详情"
      width="600px"
    >
      <div class="notification-detail">
        <div class="detail-item">
          <label>通知ID：</label>
          <span>{{ selectedNotification.id }}</span>
        </div>
        <div class="detail-item">
          <label>消息类型：</label>
          <span>{{ getTypeLabel(selectedNotification.msgType || selectedNotification.type) }}</span>
        </div>
        <div class="detail-item">
          <label>发送状态：</label>
          <div style="width: 100px;"><el-tag :type="selectedNotification.status === 1 ? 'success' : 'warning'">
            {{ selectedNotification.status === 1 ? '已发送' : '未发送' }}
          </el-tag></div>
          
        </div>
        <div class="detail-item">
          <label>操作人ID：</label>
          <span>{{ selectedNotification.opUserId }}</span>
        </div>
        <div class="detail-item">
          <label>接收人ID：</label>
          <span>{{ selectedNotification.receiverIds === 'all' ? '全部用户' : selectedNotification.receiverIds }}</span>
        </div>
        <div class="detail-item">
          <label>接收人：</label>
          <div><span v-for="(item,index) in selectedNotification.receiverNames" :key="index">{{ item }},</span></div>
          
        </div>
        <div class="detail-item">
          <label>发送时间：</label>
          <span>{{ selectedNotification.sendTime || '立即发送' }}</span>
        </div>
        <div class="detail-item">
          <label>创建时间：</label>
          <span>{{ selectedNotification.createdAt }}</span>
        </div>
        <div class="detail-item">
          <label>更新时间：</label>
          <span>{{ selectedNotification.updatedAt }}</span>
        </div>
        <div class="detail-item">
          <label>消息内容：</label>
          <div class="message-content">{{ selectedNotification.content || selectedNotification.message }}</div>
        </div>
        <div v-if="selectedNotification.extra" class="detail-item">
          <label>附加信息：</label>
          <div class="extra-content">{{ selectedNotification.extra }}</div>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { messageAPI } from '@/api'

const typeFilter = ref('')
const statusFilter = ref('')
const dateRange = ref([])
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const loading = ref(false)
const sending = ref(false)
const notificationDialogVisible = ref(false)
const notificationNum = ref([])

const notificationForm = reactive({
  type: '0', // 默认为一般消息
  priority: 'medium',
  title: '',
  message: '',
  recipients: [],
  // 设置默认发送时间为当前时间
  sendTime: null
})

const notifications = ref([])
const allNotifications = ref([]) // 添加全部通知数据的响应式变量

// 统计数据 - 使用全部数据计算
// 后端返回的 notificationNum 可能有两种常见形态：
// 1) [{ msgType: '0', total: 5 }, ...] —— 每个类型带 total 字段
// 2) [{ msgType: '0', ...}, {...}, ...] —— 原始通知数组，需要按 msgType 计数
// 这里优先使用 first.total（如果存在），否则回退到按 msgType 统计数量
const getCountByType = (type) => {
  if (!notificationNum.value) return 0
  const item = notificationNum.value.find(n => String(n.msgType) === String(type) || n.msgType === type)
  if (item && typeof item.total !== 'undefined') return Number(item.total) || 0
  // 回退：统计数组中匹配 msgType 的项数
  return notificationNum.value.filter(n => String(n.msgType) === String(type) || n.msgType === type).length
}

const commonCount = computed(() => getCountByType('0'))
const weightCount = computed(() => getCountByType('3'))
const scheduleCount = computed(() => getCountByType('1'))

// 添加详情弹窗相关的响应式变量
const detailDialogVisible = ref(false)
const selectedNotification = ref({})

// 根据新的消息类型定义获取标签
const getTypeLabel = (type) => {
  const labels = {
    '0': '一般消息',
    '1': '排班提醒',
    '2': '透析调研',
    '3': '称完体重',
    '4': '下次称体重提示',
    '5': '系统通知'
  }
  return labels[type] || '通知'
}

// 根据消息类型获取图标样式类
const getTypeIconClass = (type) => {
  const classes = {
    '0': 'common',
    '1': 'schedule',
    '2': 'research',
    '3': 'weight',
    '4': 'system'
  }
  return classes[type] || 'common'
}

const formatTime = (timeStr) => {
  const time = new Date(timeStr)
  const now = new Date()
  const diff = now - time
  
  if (diff < 60000) return '刚刚'
  if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`
  if (diff < 2592000000) return `${Math.floor(diff / 86400000)}天前`
  
  return time.toLocaleDateString()
}

// 获取通知列表 - 调用 messageList API
const fetchNotifications = async () => {
  loading.value = true
  try {
    const params = {
      pageNum: currentPage.value,
      pageSize: pageSize.value,
      status: statusFilter.value === 'unread' ? 0 : statusFilter.value === 'read' ? 1 : undefined
    }
    
    // 如果有类型筛选，添加到参数中
    if (typeFilter.value) {
      params.msgType = typeFilter.value
    }
    
    // 如果有日期范围筛选，添加到参数中
    if (dateRange.value && dateRange.value.length === 2) {
      params.startDate = dateRange.value[0]
      params.endDate = dateRange.value[1]
    }
    
    const response = await messageAPI.messageList(params)
    
    if (response.code === 0) {
      // 适配API返回的数据结构
      const records = response.data.records || []
      notifications.value = records.map(item => {
        // 解析 content 字段中的 JSON 字符串
        let parsedContent = {}
        try {
          parsedContent = JSON.parse(item.content)
        } catch (error) {
          console.warn('解析 content 失败:', error)
          // 如果解析失败，使用原始内容
          parsedContent = { msgContent: item.content, msgTitle: '通知' }
        }
        
        return {
          id: item.id,
          type: item.type || '0', // 默认为一般消息
          priority: 'medium', // 默认优先级
          title: parsedContent.msgTitle || (parsedContent.msgContent && parsedContent.msgContent.length > 20 ? parsedContent.msgContent.substring(0, 20) + '...' : parsedContent.msgContent) || '通知',
          message: parsedContent.msgContent || item.content,
          createTime: item.createdAt,
          isRead: item.status === 1, // status: 1表示已读，0表示未读
          opUserId: item.opUserId,
          receiverIds: item.receiverIds,
          receiverNames: item.receiverNames,
          sendTime: item.sendTime,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
          // 保留原始数据以备后用
          rawContent: parsedContent,
          msgData: parsedContent.msgData
        }
      })
      
      total.value = response.data.total || 0
      
      // 获取全部数据用于统计
      if (total.value > 0) {
        await fetchAllNotificationsForStats()
      }
    } else {
      ElMessage.error(response.msg || '获取通知列表失败')
      // 使用模拟数据作为后备
      loadMockData()
    }
  } catch (error) {
    console.error('获取通知列表错误:', error)
    ElMessage.error('获取通知列表失败')
    // 使用模拟数据作为后备
    loadMockData()
  } finally {
    loading.value = false
  }
}

// 获取全部通知数据用于统计
const fetchAllNotificationsForStats = async () => {
  try {
    const params = {
      // pageNum: 1,
      // pageSize: total.value, // 设置为总数，获取全部数据
      // status: statusFilter.value === 'unread' ? 0 : statusFilter.value === 'read' ? 1 : undefined
    }
    
    // // 如果有类型筛选，添加到参数中
    // if (typeFilter.value) {
    //   params.type = typeFilter.value
    // }
    
    // // 如果有日期范围筛选，添加到参数中
    // if (dateRange.value && dateRange.value.length === 2) {
    //   params.startDate = dateRange.value[0]
    //   params.endDate = dateRange.value[1]
    // }
    
    const response = await messageAPI.messageListNum(params)
    
    if (response.code === 0) {
      // 更新全部通知数据用于统计
      const allRecords = response.data || []
      notificationNum.value = allRecords
    }
  } catch (error) {
    console.error('获取全部通知数据错误:', error)
  }
}

// 模拟数据作为后备
const loadMockData = () => {
  notifications.value = [
    {
      id: 1,
      type: '4',
      priority: 'high',
      title: '系统维护通知',
      message: '系统将于今晚22:00-24:00进行维护升级，期间可能影响部分功能使用，请提前做好准备。',
      createTime: '2024-01-15 10:30:00',
      isRead: false
    },
    {
      id: 2,
      type: '3',
      priority: 'medium',
      title: '体重测量提醒',
      message: '请及时完成今日体重测量，数据将用于透析治疗计划制定。',
      createTime: '2024-01-14 14:20:00',
      isRead: false
    },
    {
      id: 3,
      type: '1',
      priority: 'high',
      title: '排班调整通知',
      message: '明日透析排班有所调整，请相关医护人员及时查看新的排班安排。',
      createTime: '2024-01-13 09:15:00',
      isRead: true
    },
    {
      id: 4,
      type: '2',
      priority: 'low',
      title: '透析调研问卷',
      message: '请完成透析治疗满意度调研问卷，您的反馈对我们很重要。',
      createTime: '2024-01-12 16:45:00',
      isRead: true
    },
    {
      id: 5,
      type: '0',
      priority: 'medium',
      title: '一般消息通知',
      message: '新的治疗指南已更新，请医护人员及时学习相关内容。',
      createTime: '2024-01-11 11:30:00',
      isRead: false
    }
  ]
  total.value = notifications.value.length
}

const toggleRead = (notification) => {
  notification.isRead = !notification.isRead
  ElMessage.success(notification.isRead ? '已标记为已读' : '已标记为未读')
}

const markAllRead = () => {
  notifications.value.forEach(n => n.isRead = true)
  ElMessage.success('已全部标记为已读')
}

const clearAll = () => {
  ElMessageBox.confirm(
    '确定要清空所有通知吗？此操作不可恢复。',
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    notifications.value = []
    total.value = 0
    ElMessage.success('已清空所有通知')
  })
}

const sendNotification = () => {
  Object.assign(notificationForm, {
    type: '0', // 默认为一般消息
    priority: 'medium',
    title: '',
    message: '',
    recipients: [],
    // 设置默认发送时间为当前时间
    sendTime: new Date().toISOString().slice(0, 19).replace('T', ' ')
  })
  notificationDialogVisible.value = true
}

const sendNotificationSubmit = async () => {
  if (!notificationForm.message) {
    ElMessage.error('请填写通知内容')
    return
  }
  
  sending.value = true
  try {
    // 适配API要求的数据结构
    const messageData = {
      content: notificationForm.message,           // 通知内容
      receiverIds: notificationForm.recipients.length > 0 ? notificationForm.recipients.join(',') : 'all',  // 接收者ID
      sendTime: notificationForm.sendTime || new Date().toISOString(),  // 发送时间
      title:notificationForm.title
    }
    
    const response = await messageAPI.addMessage(messageData)
    
    if (response.code === 0) {
      notificationDialogVisible.value = false
      
      if (notificationForm.sendTime) {
        ElMessage.success(`通知已安排发送，发送时间：${notificationForm.sendTime}`)
      } else {
        ElMessage.success('通知发送成功')
      }
      
      // 重新获取通知列表
      fetchNotifications()
    } else {
      ElMessage.error(response.msg || '发送通知失败')
    }
  } catch (error) {
    console.error('发送通知错误:', error)
    ElMessage.error('发送通知失败')
  } finally {
    sending.value = false
  }
}

const viewDetail = (notification) => {
  selectedNotification.value = notification
  detailDialogVisible.value = true
}

const deleteNotification = (notification) => {
  ElMessageBox.confirm(
    `确定要删除通知"${notification.title}"吗？`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'info',
    }
  ).then(() => {
    const index = notifications.value.findIndex(n => n.id === notification.id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
    ElMessage.success('删除成功')
  })
}

const refreshNotifications = () => {
  fetchNotifications()
}

const handleSizeChange = (val) => {
  pageSize.value = val
  currentPage.value = 1
  fetchNotifications()
}

const handleCurrentChange = (val) => {
  currentPage.value = val
  fetchNotifications()
}

// 组件挂载时获取通知列表
onMounted(() => {
  fetchNotifications()
})
</script>

<style scoped>
.notification-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  font-size: 28px;
  color: #1e293b;
  margin: 0 0 10px 0;
}

.page-header p {
  color: #64748b;
  margin: 0;
}

.notification-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.stat-icon.unread {
  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);
}

.stat-icon.system {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
}

.stat-icon.user {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stat-icon.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.stat-icon.weight {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stat-icon.schedule {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.stat-icon.research {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
}

.stat-icon.common {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.stat-label {
  color: #64748b;
  font-size: 14px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-section {
  display: flex;
  gap: 16px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.notification-list {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 0;
  margin-bottom: 20px;
}

.list-header h3 {
  margin: 0;
  color: #1e293b;
}

.notification-items {
  padding: 0 24px;
  min-height: 200px;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.notification-item:hover {
  background: #f8fafc;
}

.notification-item.unread {
  background: #f0f9ff;
}

.notification-item.important {
  border-left: 4px solid #ef4444;
}

.notification-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #e0e7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6366f1;
  flex-shrink: 0;
}

.notification-content {
  flex: 1;
  min-width: 0;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.notification-title {
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.notification-time {
  font-size: 12px;
  color: #94a3b8;
  flex-shrink: 0;
}

.notification-message {
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 12px;
}

.notification-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-type {
  font-size: 12px;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 4px;
}

.notification-actions {
  display: flex;
  gap: 8px;
}

.notification-status {
  position: relative;
  flex-shrink: 0;
}

.unread-dot {
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.pagination-wrapper {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.notification-detail {
  padding: 20px 0;
}

.detail-item {
  display: flex;
  margin-bottom: 16px;
  align-items: flex-start;
}

.detail-item label {
  font-weight: 600;
  color: #606266;
  min-width: 100px;
  margin-right: 12px;
}

.detail-item span {
  color: #303133;
  flex: 1;
}

.message-content {
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  border-left: 4px solid #409eff;
  white-space: pre-wrap;
  word-break: break-word;
  margin-top: 4px;
}

.extra-content {
  background: #f0f9ff;
  padding: 12px;
  border-radius: 4px;
  border-left: 4px solid #67c23a;
  white-space: pre-wrap;
  word-break: break-word;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .action-bar {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .filter-section {
    flex-direction: column;
  }
  
  .action-buttons {
    justify-content: center;
  }
  
  .notification-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .notification-header {
    flex-direction: column;
    gap: 8px;
  }
  
  .notification-footer {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
}
</style>